// extracted by mini-css-extract-plugin
module.exports = {"wrapperPictures":"index_wrapperPictures__1DAnh","uploadPictureButton":"index_uploadPictureButton__UmdQo","iconDelete":"index_iconDelete__1tcwD"};